import { DialogProcessorActions } from 'app/actions/dialogprocessor/dialogProcessorActions.ts';
import { VoiceRecognitionActions } from 'app/actions/voiceRecognition/voiceRecognitionActions.ts';
import { speechRecognizeSpeech } from '@/api-gen/api.ts';
import * as RecognitionSelector from 'app/selectors/voiceRecognitionSelector.ts';
import * as ScenarioSelectors from 'app/selectors/scenarioSelectors.ts';
import type { AxiosResponse } from 'axios';
import type { Action } from 'redux-actions';
import { all, call, put, select, takeLatest } from 'redux-saga/effects';
import logger from 'app/utils/logger.ts';

const mimeToExt: Record<string, string> = {
  'audio/webm': 'webm',
  'audio/webm;codecs=opus': 'webm',
  'audio/ogg': 'ogg',
  'audio/mpeg': 'mp3',
  'audio/wav': 'wav',
  'audio/x-wav': 'wav',
  'audio/mp4': 'm4a',
  'audio/aac': 'aac',
  'audio/3gpp': '3gp',
  'audio/3gpp2': '3g2'
};

const guessFilenameFromBlob = (blob: Blob) => {
  const type = (blob.type || '').toLowerCase();
  const baseType = type.split(';')[0];
  const ext = mimeToExt[baseType] ?? (baseType.includes('/') ? baseType.split('/')[1] : 'bin');
  return `audio.${ext}`;
};

function* getAudioOfLastIntent(action: Action<{ audio: null | Blob; speechBase64?: string }>) {
  const speechBase64 = action.payload.speechBase64 ?? '';

  try {
    const language: string = yield select(ScenarioSelectors.currentChartScenarioLang);
    const formData = new FormData();
    if (action.payload.audio) {
      formData.append('file', action.payload.audio, guessFilenameFromBlob(action.payload.audio));
    }
    const result: AxiosResponse<string> = yield call(speechRecognizeSpeech, formData as any, { lng: language });

    const recognizedText = result.data?.trim();

    if (recognizedText === '##!!!ERROR_STRING!!!##') {
      // fallback to browser STT
      yield put(VoiceRecognitionActions.setUseFallbackStt(true));
      const fallbackString = yield select(RecognitionSelector.fallbackSttTextSelector);

      yield put(VoiceRecognitionActions.setLatestInhouseText(fallbackString));
      yield put(
        DialogProcessorActions.getResponseData({
          speechBase64,
          text: fallbackString
        })
      );
    } else {
      yield put(VoiceRecognitionActions.setLatestInhouseText(recognizedText));
      yield put(
        DialogProcessorActions.getResponseData({
          speechBase64,
          text: recognizedText
        })
      );
    }
  } catch (e) {
    logger.error(e);

    yield put(VoiceRecognitionActions.setLatestInhouseText(''));
    yield put(DialogProcessorActions.getResponseData({ text: '', speechBase64 }));
  }
}

export default function* watchSpeechToTextSaga() {
  yield all([yield takeLatest(VoiceRecognitionActions.Type.PARSE_LATEST_AUDIO, getAudioOfLastIntent)]);
}
